export function generateRandomArray<T>(fn: () => T, count = 10): T[] {
  const array: T[] = [];
  for (let i = 0; i < count; i++) {
    array.push(fn());
  }
  return array;
}
